import About from './About';

export { About };
export default About;
